import React from 'react';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { useDispatch, useSelector } from 'react-redux';
import { hasLineItemsInOrderSelected } from '../../../../../../selectors/tools';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { CustomNoResultsComponentContextProvider } from '../../Common/NoSearchResults/CustomNoResultsComponentContext';
import { DTNoResultsLink } from '../../../../Common/DTNoResultsLink/DTNoResultsLink';

const DTSelectOrderAndLineItemsNode = () => {
  const dispatch = useDispatch();
  const hasLineItemsSelected = useSelector(hasLineItemsInOrderSelected);

  const handleNextButtonClick = () => {
    dispatch(addEdgeToDecisionTreePath('items_selected'));
  };

  return (
    <CustomNoResultsComponentContextProvider value={<DTNoResultsLink />}>
      <DTOrderSearchView onNextButtonClick={handleNextButtonClick} isNextButtonActive={hasLineItemsSelected} />
    </CustomNoResultsComponentContextProvider>
  );
};

export default DTSelectOrderAndLineItemsNode;
